import React from 'react';
import {
  Badge,
  Box,
  Flex,
  Grid,
  GridItem,
  Image,
  Text,
} from '@chakra-ui/react';

import logo from '../../../assets/logo2026.png';

interface FormLetterheadProps {
  demo?: boolean;
}

/**
 * Cabeçalho oficial do RG 26/POP 05 (COOASGO), reproduzindo o formulário em
 * papel: logo à esquerda, título e código/emissão/revisão/versão à direita.
 */
export const FormLetterhead: React.FC<FormLetterheadProps> = ({ demo }) => (
  <Box
    borderWidth="1px"
    borderColor="gray.700"
    borderRadius="lg"
    overflow="hidden"
    mb="6"
  >
    <Flex borderBottomWidth="1px" borderColor="gray.700">
      <Flex
        align="center"
        justify="center"
        p={{ base: '2', md: '4' }}
        borderRightWidth="1px"
        borderColor="gray.700"
        minW={{ base: '80px', md: '150px' }}
      >
        <Image src={logo} alt="COOASGO" maxH={{ base: '56px', md: '90px' }} />
      </Flex>
      <Flex
        direction="column"
        justify="center"
        p={{ base: '3', md: '4' }}
        flex="1"
        gridGap="1"
      >
        <Flex align="center" gridGap="3" flexWrap="wrap">
          <Text
            fontWeight="700"
            fontSize={{ base: 'xs', sm: 'sm', md: 'lg' }}
            lineHeight="1.3"
          >
            REGISTRO DE CONTROLE DE NÃO CONFORMIDADES, ANÁLISE DE CAUSAS E AÇÕES
            CORRETIVAS E PREVENTIVAS
          </Text>
          {demo && <Badge colorScheme="purple">Demonstração</Badge>}
        </Flex>
      </Flex>
    </Flex>

    <Grid
      templateColumns={{ base: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' }}
      fontSize={{ base: 'xs', md: 'sm' }}
    >
      <GridItem p="2" borderRightWidth="1px" borderColor="gray.700">
        <Text as="span" fontWeight="600">
          Código:
        </Text>{' '}
        RG 26/POP 05
      </GridItem>
      <GridItem
        p="2"
        borderRightWidth={{ base: '0', md: '1px' }}
        borderColor="gray.700"
      >
        <Text as="span" fontWeight="600">
          Emissão:
        </Text>{' '}
        02/01/2026
      </GridItem>
      <GridItem
        p="2"
        borderRightWidth="1px"
        borderTopWidth={{ base: '1px', md: '0' }}
        borderColor="gray.700"
      >
        <Text as="span" fontWeight="600">
          Revisão:
        </Text>{' '}
        01
      </GridItem>
      <GridItem
        p="2"
        borderTopWidth={{ base: '1px', md: '0' }}
        borderColor="gray.700"
      >
        <Text as="span" fontWeight="600">
          Versão:
        </Text>{' '}
        02
      </GridItem>
    </Grid>
  </Box>
);
